var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "预设配置",
        visible: _vm.dialogVisible,
        width: "90%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            "label-position": "left",
            "label-width": "120px",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "配置类型", prop: "checkedType" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择配置类型", filterable: "" },
                  on: { change: _vm.onConfigTypeChange },
                  model: {
                    value: _vm.ruleForm.checkedType,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "checkedType", $$v)
                    },
                    expression: "ruleForm.checkedType",
                  },
                },
                _vm._l(_vm.configTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "操作", prop: "changeState" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.changeState,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "changeState", $$v)
                    },
                    expression: "ruleForm.changeState",
                  },
                },
                _vm._l(_vm.changeStateList, function (item, index) {
                  return _c(
                    "el-radio",
                    { key: index, attrs: { label: item.value } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "预计可导订单数", prop: "orders" } },
            [
              _c("el-input-number", {
                attrs: { min: 0, label: "请输入可导订单" },
                model: {
                  value: _vm.todayOrders,
                  callback: function ($$v) {
                    _vm.todayOrders = $$v
                  },
                  expression: "todayOrders",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.ruleForm.checkedType
            ? _c(
                "el-form-item",
                { attrs: { label: "模型比例配置" } },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "20px" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          format: "yyyy 年 MM 月 dd 日",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.datePickerOptions,
                        },
                        on: { change: _vm.onDateChange },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-plus",
                            disabled: !_vm.canAddPresetDate,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addPresetDate()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    添加预设日期\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.canAddPresetDate && _vm.date
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f56c6c",
                                "margin-left": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.dateValidationMessage) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.allConfigItems.length === 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            padding: "40px",
                            color: "#999",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-calendar",
                            staticStyle: {
                              "font-size": "48px",
                              "margin-bottom": "16px",
                            },
                          }),
                          _vm._v(" "),
                          _c("p", [_vm._v("暂无预设配置，请先添加预设日期")]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "margin-top": "8px",
                              },
                            },
                            [
                              _vm._v(
                                '\n                    选择明天或以后的日期，然后点击"添加预设日期"\n                '
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allConfigItems.length > 0
                    ? _c(
                        "el-tabs",
                        {
                          attrs: { type: "border-card" },
                          on: { "tab-click": _vm.onTabClick },
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.allConfigItems, function (item, index) {
                          return _c(
                            "el-tab-pane",
                            {
                              key: index,
                              attrs: {
                                label: item.date,
                                name: "preset-" + index,
                              },
                            },
                            [
                              item.hasUnsavedChanges
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#f56c6c",
                                        "margin-bottom": "10px",
                                        display: "inline-block",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        * 有未保存的修改\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-tabs",
                                {
                                  model: {
                                    value: item.innerActiveTab,
                                    callback: function ($$v) {
                                      _vm.$set(item, "innerActiveTab", $$v)
                                    },
                                    expression: "item.innerActiveTab",
                                  },
                                },
                                [
                                  _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: "强导配置值",
                                        name: "content",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "padding-bottom": "20px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-plus",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addPresetPattern(
                                                    item,
                                                    "ratioList"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    添加模型和比例\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    总比例："
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  style: {
                                                    color:
                                                      _vm.getPresetTotalRatio(
                                                        item.ratioList
                                                      ) > 100
                                                        ? "#f56c6c"
                                                        : "inherit",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getPresetTotalRatio(
                                                        item.ratioList
                                                      )
                                                    ) + "%"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "padding-left": "20px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "总上限：" +
                                                  _vm._s(
                                                    _vm.getPresetTotalLimit(
                                                      item.ratioList
                                                    )
                                                  ) +
                                                  " 单"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      item.ratioList.length === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "center",
                                                padding: "40px",
                                                color: "#999",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-plus",
                                                staticStyle: {
                                                  "font-size": "48px",
                                                  "margin-bottom": "16px",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  '暂无模型配置，请点击"添加模型和比例"按钮'
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        item.ratioList,
                                        function (ratioItem, ratioIndex) {
                                          return item.ratioList.length > 0
                                            ? _c(
                                                "el-form",
                                                {
                                                  key: "content-" + ratioIndex,
                                                  staticStyle: {
                                                    "margin-bottom": "10px",
                                                  },
                                                  attrs: { inline: true },
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass:
                                                            "width-200",
                                                          attrs: {
                                                            placeholder:
                                                              "选择或填写模型",
                                                            filterable: "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onPresetSelectChange(
                                                                item,
                                                                ratioIndex,
                                                                "ratioList"
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              ratioItem.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                ratioItem,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "ratioItem.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.patternList,
                                                          function (
                                                            patternItem
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: patternItem.value,
                                                                attrs: {
                                                                  label:
                                                                    patternItem.label,
                                                                  value:
                                                                    patternItem.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: { label: "比例" },
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        staticClass:
                                                          "width-120",
                                                        attrs: {
                                                          min: 0,
                                                          max: 100,
                                                          precision: 0,
                                                          label: "比例",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.updatePresetOrders(
                                                              item
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            ratioItem.weight,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              ratioItem,
                                                              "weight",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "ratioItem.weight",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "预计订单",
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "70px",
                                                        },
                                                        attrs: {
                                                          value:
                                                            ratioItem.orders,
                                                          readOnly: "",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  !ratioItem.showLimit &&
                                                  ratioItem.limit === 0
                                                    ? _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.openPresetLimitConfig(
                                                                      item,
                                                                      ratioIndex,
                                                                      "ratioList"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                        配置上限\n                                    "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "el-form-item",
                                                        [
                                                          _vm._v(
                                                            "\n                                    上限\n                                    "
                                                          ),
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "width-120",
                                                              attrs: {
                                                                min: 0,
                                                                precision: 0,
                                                                label: "比例",
                                                              },
                                                              model: {
                                                                value:
                                                                  ratioItem.limit,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      ratioItem,
                                                                      "limit",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ratioItem.limit",
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(
                                                            "\n                                    单\n                                "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-form-item",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deletePresetPattern(
                                                                item,
                                                                ratioIndex,
                                                                "ratioList"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("删除")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-form-item",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goPatternDetail(
                                                                ratioItem.value
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("查看配置")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  item.showSContentTab
                                    ? _c(
                                        "el-tab-pane",
                                        {
                                          attrs: {
                                            label: "特殊配置值",
                                            name: "s_content",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "padding-bottom": "20px",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    icon: "el-icon-plus",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addPresetPattern(
                                                        item,
                                                        "sRatioList"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    添加模型和比例\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    总比例："
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      style: {
                                                        color:
                                                          _vm.getPresetTotalRatio(
                                                            item.sRatioList
                                                          ) > 100
                                                            ? "#f56c6c"
                                                            : "inherit",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getPresetTotalRatio(
                                                            item.sRatioList
                                                          )
                                                        ) + "%"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "padding-left": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "总上限：" +
                                                      _vm._s(
                                                        _vm.getPresetTotalLimit(
                                                          item.sRatioList
                                                        )
                                                      ) +
                                                      " 单"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          item.sRatioList.length === 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "text-align": "center",
                                                    padding: "40px",
                                                    color: "#999",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                    staticStyle: {
                                                      "font-size": "48px",
                                                      "margin-bottom": "16px",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      '暂无模型配置，请点击"添加模型和比例"按钮'
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            item.sRatioList,
                                            function (ratioItem, ratioIndex) {
                                              return item.sRatioList.length > 0
                                                ? _c(
                                                    "el-form",
                                                    {
                                                      key:
                                                        "s_content-" +
                                                        ratioIndex,
                                                      staticStyle: {
                                                        "margin-bottom": "10px",
                                                      },
                                                      attrs: { inline: true },
                                                    },
                                                    [
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticClass:
                                                                "width-200",
                                                              attrs: {
                                                                placeholder:
                                                                  "选择或填写模型",
                                                                filterable: "",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onPresetSelectChange(
                                                                      item,
                                                                      ratioIndex,
                                                                      "sRatioList"
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  ratioItem.value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      ratioItem,
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ratioItem.value",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.patternList,
                                                              function (
                                                                patternItem
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: patternItem.value,
                                                                    attrs: {
                                                                      label:
                                                                        patternItem.label,
                                                                      value:
                                                                        patternItem.value,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "比例",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-input-number",
                                                            {
                                                              staticClass:
                                                                "width-120",
                                                              attrs: {
                                                                min: 0,
                                                                max: 100,
                                                                precision: 0,
                                                                label: "比例",
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.updatePresetOrders(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  ratioItem.weight,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      ratioItem,
                                                                      "weight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "ratioItem.weight",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-form-item",
                                                        {
                                                          attrs: {
                                                            label: "预计订单",
                                                          },
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width: "70px",
                                                            },
                                                            attrs: {
                                                              value:
                                                                ratioItem.orders,
                                                              readOnly: "",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      !ratioItem.showLimit &&
                                                      ratioItem.limit === 0
                                                        ? _c(
                                                            "el-form-item",
                                                            [
                                                              _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    type: "text",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openPresetLimitConfig(
                                                                          item,
                                                                          ratioIndex,
                                                                          "sRatioList"
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        配置上限\n                                    "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "el-form-item",
                                                            [
                                                              _vm._v(
                                                                "\n                                    上限\n                                    "
                                                              ),
                                                              _c(
                                                                "el-input-number",
                                                                {
                                                                  staticClass:
                                                                    "width-120",
                                                                  attrs: {
                                                                    min: 0,
                                                                    precision: 0,
                                                                    label:
                                                                      "比例",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      ratioItem.limit,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          ratioItem,
                                                                          "limit",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "ratioItem.limit",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                                    单\n                                "
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deletePresetPattern(
                                                                      item,
                                                                      ratioIndex,
                                                                      "sRatioList"
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("删除")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-form-item",
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.goPatternDetail(
                                                                      ratioItem.value
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("查看配置")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !item.showSContentTab
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-plus",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onAddSContentForPreset(
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        添加特殊配置值\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "30px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.savePresetConfig(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            "保存 " + item.date + " 配置"
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deletePresetDate(
                                            item,
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            删除预设配置\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }